module.exports = __webpack_public_path__ + "static/media/geoffpleiss_dei_statement.e69ed76a.pdf";